import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "modal-right",
  id: "confirmationStep"
}
const _hoisted_2 = { class: "modal-body scroll-wrapper" }
const _hoisted_3 = { class: "content-step" }
const _hoisted_4 = { class: "content-text" }
const _hoisted_5 = {
  key: 0,
  class: "info-lot"
}
const _hoisted_6 = { class: "content-lot-details-img" }
const _hoisted_7 = { class: "content-lot-details" }
const _hoisted_8 = { class: "lot-img" }
const _hoisted_9 = ["viewBox"]
const _hoisted_10 = ["d"]
const _hoisted_11 = { class: "house-info-card" }
const _hoisted_12 = { class: "content-selections-modal" }
const _hoisted_13 = { class: "content-selections" }
const _hoisted_14 = { class: "house-info-card-header" }
const _hoisted_15 = { class: "content-logo" }
const _hoisted_16 = { class: "builder-logo-wr" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "content-features-facade"
}
const _hoisted_19 = { class: "title-house-facade" }
const _hoisted_20 = { class: "content-area-features" }
const _hoisted_21 = { class: "area-house-design" }
const _hoisted_22 = { class: "content-features" }
const _hoisted_23 = { class: "house-info-card-row-quote" }
const _hoisted_24 = { class: "container-value-edit" }
const _hoisted_25 = { class: "row-value" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "house-info-card-row-quote" }
const _hoisted_28 = { class: "container-value-edit" }
const _hoisted_29 = { class: "row-value" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "house-info-card-row-quote" }
const _hoisted_32 = { class: "container-value-edit" }
const _hoisted_33 = { class: "row-value" }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 0,
  class: "content-features-facade-img"
}
const _hoisted_36 = { class: "content-image-facade" }
const _hoisted_37 = {
  key: 0,
  class: "content-details-step"
}
const _hoisted_38 = { class: "content-house-design-features" }
const _hoisted_39 = { class: "content-house-design" }
const _hoisted_40 = { class: "title-house-design" }
const _hoisted_41 = { class: "content-features" }
const _hoisted_42 = { class: "area-house-design" }
const _hoisted_43 = { class: "content-image-facade" }
const _hoisted_44 = { class: "content-floorplan" }
const _hoisted_45 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info-title" }, "Your Home and Land Package", -1)),
          (!$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Lot " + _toDisplayString($props.lot?.title), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["BuilderLotDetails"], {
              lot: $props.lot,
              estate: $props.estate,
              isBuilderView: true
            }, null, 8, ["lot", "estate"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock("svg", {
              class: "item-wr svg-img",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              version: "1.1",
              viewBox: `0 0 ${$props.lotForBuilder?.size.width} ${$props.lotForBuilder?.size.height}`
            }, [
              _createElementVNode("path", {
                class: "item-path",
                d: $props.lotForBuilder?.path
              }, null, 8, _hoisted_10)
            ], 8, _hoisted_9))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  ($setup.selectedQuote?.builder.id)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: $setup.selectedQuote.builder.logo,
                        alt: "builder logo"
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            ($setup.isDesktop)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString($setup.selectedQuote.house?.name), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign?.area, false)) + " sqm", 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode($setup["HouseFeatures"], {
                        features: $setup.selectedHouseDesign,
                        class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile'),
                        iconSize: 'tiny',
                        directionLogo: true
                      }, null, 8, ["features", "class"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_23, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-label" }, "Builder:", -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString($setup.selectedQuote.builder.name), 1),
                  ($setup.selectedQuote.builder.name)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button button-with-icon",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onUpdateUserSelectionBuilder($setup.selectedQuote)))
                      }, [
                        _createElementVNode("img", {
                          src: require(`@/assets/icons/edit-slate-icon-green.svg`)
                        }, null, 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-label" }, "Design:", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString($setup.selectedQuote.house.name), 1),
                  ($setup.selectedQuote.house.name)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button button-with-icon",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onUpdateUserSelectionDesignAndFloorplan($setup.selectedQuote)))
                      }, [
                        _createElementVNode("img", {
                          src: require(`@/assets/icons/edit-slate-icon-green.svg`)
                        }, null, 8, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-label" }, "Exterior Facade:", -1)),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString($setup.selectedQuote.facade?.name), 1),
                  ($setup.selectedQuote.facade?.name)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button button-with-icon",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onUpdateUserSelectionFacade($setup.selectedQuote)))
                      }, [
                        _createElementVNode("img", {
                          src: require(`@/assets/icons/edit-slate-icon-green.svg`)
                        }, null, 8, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        ($setup.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode($setup["CustomizeHouseSlider"], {
                  sliderImages: $setup.sliderImages,
                  showArrows: false
                }, null, 8, ["sliderImages"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (!$setup.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, _toDisplayString($setup.selectedHouseDesign?.name), 1),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode($setup["HouseFeatures"], {
                    features: $setup.selectedHouseDesign ?? _ctx.house,
                    class: _normalizeClass($setup.isDesktop ? 'house-features' : 'house-features-mobile')
                  }, null, 8, ["features", "class"])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, _toDisplayString($setup.formatMeters($setup.selectedHouseDesign?.area, false)) + " sqm", 1),
              _createElementVNode("div", _hoisted_43, [
                _createVNode($setup["CustomizeHouseSlider"], {
                  sliderImages: $setup.sliderImages,
                  showArrows: false
                }, null, 8, ["sliderImages"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("img", {
                src: $setup.selectedHouseDesign?.floorplans[0]?.url,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openImageModal && _ctx.openImageModal(...args)))
              }, null, 8, _hoisted_45)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}